import { useQuery } from '@tanstack/solid-query'
import { getServiceClient } from '~/lib/api'
import { inStep } from '~/lib/load-failure'
import { queryClient } from '~/lib/query-client'

type Balance = {
  coin: number
  gem: number
}

const balanceQueryKey = ['user']

export function useBalanceQuery() {
  return useQuery(() => ({
    queryKey: balanceQueryKey,
    queryFn: () =>
      inStep('load_balance', () =>
        getServiceClient().then(({ client }) =>
          client.get(`user/users/current`).json<Balance>(),
        ),
      ),
  }))
}

export function setBalance(update: (balance: Balance) => Balance) {
  queryClient.setQueryData(balanceQueryKey, update)
}

export function invalidateBalance() {
  return queryClient.invalidateQueries({ queryKey: balanceQueryKey })
}
